export default "__VITE_ASSET__MWhpNZLr__"